import React from 'react'
import type { FunctionComponent } from 'react'
import { View } from 'react-native'

import privacy from '../../assets/privacy.png'
import { tID } from '../../utils/utils'
import { Image } from '../image/Image'

type PrivacyIllustrationProps = {
  width?: number
  height?: number
}

export const PrivacyIllustration: FunctionComponent<PrivacyIllustrationProps> = ({ width = 129, height = 112 }) => {
  return (
    <View>
      {/* eslint-disable-next-line react-native-a11y/has-valid-accessibility-ignores-invert-colors */}
      <Image
        source={privacy}
        testID={`${tID('PrivacyIllustration')}`}
        accessibilityLabel={'privacy'}
        style={{ width, height }}
      />
    </View>
  )
}
